import { useContext, useState } from "react";
import TextField from "@mui/material/TextField";
import RTL from "../../../helpers/direction/RTL";
import UserIcon from "../../../styles/icon/person_outline.svg";
import ReferralIcon from "../../../styles/icon/referralcode.svg";
import { Link } from "react-router-dom";
import styles from "./Register.module.scss";
import { context } from "../../../context/context";

export default function RegisterNum() {
  const [checkFocuse, setCheckFocuse] = useState("");
  const registerCTX = useContext(context);
  const {
    newReferral,
    setNewReferral,
    newUserNumber,
    setNewUserNumber,
    handleRegisterNum,
    validatorRegister,
    setValidatorRegister,
  } = registerCTX;

  return (
    <>
      <form onSubmit={(e) => handleRegisterNum(e)}>
        <section className={styles.inputs_place}>
          <div
            className={`changeTextFieldBackgroundToWhite ${styles.mobile_place}`}
          >
            <RTL>
              <TextField
                className={styles.number_login_input}
                type="number"
                name="newUserNum"
                label="شماره موبایل"
                color="success"
                onFocus={() => setCheckFocuse("mobile")}
                onBlur={() => setCheckFocuse("")}
                value={newUserNumber}
                onChange={(e) => {
                  setNewUserNumber(e.target.value);
                  setValidatorRegister({ ...validatorRegister, number: "" });
                }}
              />

              <div
                className={`${styles.icon_place}  ${styles.first_input_icon} ${
                  checkFocuse === "mobile" ? styles.icon_place_active : ""
                }`}
              >
                <img src={UserIcon} alt="" className="convertPicToGreen" />
              </div>
              <div className={styles.errorMessage}>
                {validatorRegister.number}
              </div>
            </RTL>
          </div>
          <div
            className={`changeTextFieldBackgroundToWhite ${styles.pass_place}`}
          >
            <RTL>
              <TextField
                label="کد معرف(اختیاری)"
                color="success"
                onFocus={() => setCheckFocuse("referral")}
                onBlur={() => setCheckFocuse("")}
                value={newReferral}
                onChange={(e) => setNewReferral(e.target.value)}
              />

              <div
                className={`${styles.icon_place} ${
                  checkFocuse === "referral" ? styles.icon_place_active : ""
                }`}
              >
                <img src={ReferralIcon} alt="" className="convertPicToGreen" />
              </div>
            </RTL>
          </div>
        </section>

        <div className={styles.button_container}>
          <button type="submit">ادامه</button>
          <Link to="/authorization/login">
            <div className={`font_color_white ${styles.register_div}`}>
              قبلا ثبت نام کردید؟ وارد شوید
            </div>
          </Link>
        </div>
      </form>
    </>
  );
}
